import { Box, Container, ScrollArea } from '@collinsonx/design-system/core';
import { useViewportSize } from '@collinsonx/design-system/hooks';
import AppLogo from 'components/AppLogo';
import usePayload from 'hooks/usePayload';
import { ReactNode } from 'react';

import classes from './LayoutLogin.module.css';

interface LayoutProps {
  children: ReactNode;
}

export default function LayoutLogin({ children }: LayoutProps) {
  const { payload } = usePayload();
  const { height } = useViewportSize();

  return (
    <ScrollArea type="never">
      <Container
        className={classes.container}
        fluid
        px={0}
        style={{
          minHeight: `${height}px`,
        }}
      >
        <div className={classes.container2}>
          {payload && (
            <Box className={classes.container3}>
              <Box className={classes.logoWrapper} mb={2} mt={2}>
                <AppLogo
                  accountProvider={payload.accountProvider}
                  membershipType={payload.membershipType}
                />
              </Box>
            </Box>
          )}
        </div>
        <Box className={classes.contentWrapper}>{children}</Box>
      </Container>
    </ScrollArea>
  );
}
